
import { environment as defaultEnvironment } from './environment';
function httpGetAsync(theUrl, callback) {
  const xmlHttp = new XMLHttpRequest();

  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
      callback(xmlHttp.responseText);
    }
  }

  xmlHttp.open('GET', theUrl, true); // true for asynchronous
  xmlHttp.send(null);
}

   export const environmentLoader = new Promise<any>((resolve, reject) => {
    // var content = require('../assets/environment.json');
     httpGetAsync('assets/environment.json', (content: string) => {
       console.log(JSON.parse(content));
       if (content != null) {
         resolve(JSON.parse(content));
       }
       else
         resolve(defaultEnvironment);
     });
   

  });


